import { invalidValue } from './validation.js';

export const MONTHS_OF_YEAR = Object.freeze([
    'Январь', 'Февраль', 'Март',
    'Апрель', 'Май', 'Июнь',
    'Июль', 'Август', 'Сентябрь',
    'Октябрь', 'Ноябрь', 'Декабрь',
]);


export const DAY_OF_WEEK = Object.freeze([
    'пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс',
]);


export function equalDates(a, b) {
    if (a == b)
        return true;

    if (!(a instanceof Date) || !(b instanceof Date))
        return false;

    return a.getFullYear() === b.getFullYear()
        && a.getMonth() === b.getMonth()
        && a.getDate() === b.getDate();
}


export function generateDays(year, month) {
    const result = [];
    const date = new Date(year, month, 1, 0, 0, 0, 0);

    while (date.getDay() !== 1) {
        date.setDate(date.getDate() - 1);
    }

    const nextMonth = month === 11 ? 0 : month + 1;

    do {
        result.push(new Date(date));

        date.setDate(date.getDate() + 1);
    } while (!(date.getDay() === 1 && date.getMonth() === nextMonth));

    return result;
}


export function changeMonth(date, delta) {
    if (!(date instanceof Date))
        throw new TypeError('Parameter #1:date is not Date');

    const temp = new Date(date);
    temp.setMonth(temp.getMonth() + (delta | 0));
    return temp;
}


export function sortIfNeeded(result) {

    if (result[1] && result[0] > result[1]) {
        const temp = result[1];
        result[1] = result[0];
        result[0] = temp;
    }

    return result;
}


export function getTime(source, index) {
    if (source == null)
        return null;

    if (Array.isArray(source))
        return getTime(source[index]);

    const h = source.getHours();
    const m = source.getMinutes();

    return h * 60 + m;
}


export function scalarEquals(a, b) {
    if (a == b)
        return true;

    if (!(a instanceof Date) || !(b instanceof Date))
        return false;

    return a.getTime() === b.getTime();
}


export function vectorEquals(a, b) {
    if (a == b)
        return true;

    if (!Array.isArray(a) || !Array.isArray(b))
        return false;

    if (a.length !== b.length)
        return false;

    for (let i = 0; i < a.length; i++) {
        if (!scalarEquals(a[i], b[i]))
            return false;
    }

    return true;
}


export function timestampVectorEquals(a, b) {
    if (a === b)
        return true;

    if (!Array.isArray(a) || !Array.isArray(b))
        return false;

    if (a.length !== b.length)
        return false;

    for (let i = 0; i < a.length; i++) {
        if (a[i] !== b[i])
            return false;
    }

    return true;
}


export function findLastIndex(source, predicate) {
    if (!Array.isArray(source))
        throw new TypeError('Parameter #1:source is not Array');

    for (let i = source.length; --i >= 0;) {
        if (predicate(source[i]))
            return i;
    }

    return -1;
}


function transformScalar(source) {
    if (source == null)
        return null;

    if (source instanceof Date)
        return source;

    if (typeof (source) === 'number')
        return new Date(source);

    throw invalidValue(source);
}


export function toInnerState(source) {
    if (!Array.isArray(source))
        return transformScalar(source);

    return source.map(transformScalar);
}
